<template>
    <div>
        <div class="popup__header">
            <span class="title title--sm popup__title">{{ $lang('editBurial.title') }}</span>
        </div>
        <div class="popup__content">
            <form class="form" @submit.prevent="updateBurial">
                <label class="form__item">
                    <span class="form__label">{{ $lang('editBurial.name') }}</span>
                    <el-input class="input input--big" :placeholder="$lang('editBurial.placeholder')" v-model="name" required></el-input>
                </label>
                <div class="form__item">
                    <button class="btn btn--middle btn--main-bg btn--w100">{{ $lang('editBurial.button') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import ApiService from '../../api/api';

    export default {
        name: "editBurial",
        props: ['burial_id', 'nameBurial'],
        data: () => ({
            windowWidth: window.innerWidth,
            name: '',
            isAdmin: window.laravel.isAdmin,
            isMaster: window.laravel.isMaster,
            isPartner: window.laravel.isPartner,
        }),
        methods: {
            updateBurial() {
                ApiService.post('/page/edit-burial', {
                    burial_id: this.burial_id,
                    name: this.name
                })
                    .then((response) => {
                        window.location.href = window.laravel.prefix + '/cabinet/pages/related';
                    }).catch((error) => {
                        console.log(error);
                    });
            }
        },
        mounted() {
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
            });

            if (this.nameBurial) {
                this.name = this.nameBurial;
            }
        },
    }
</script>

<style>
    .popup__description {
        margin-top: 15px;
    }
</style>
